let shopApi={}
shopApi.cartUpdateTimer=undefined;

shopApi.addToCart=(articleNumber, amount=1, updateCartCounter=true, additionalData="")=>{
    return new Promise((resolve,reject)=>{
         $.get(`/api/cart/add?article=${articleNumber}&amount=${amount}&additionalData=${additionalData}`, function(data){
            resolve(data);
            if(updateCartCounter){
                shopApi.updateCartCounter();
            }
        }).fail(()=>{
            reject();
        });
    });
};

shopApi.updateCartPosition=(snr, amount, pos16511=-1, reload=true)=>{
    return new Promise((resolve,reject)=>{
        $.get(`/api/cart/update?snr=${snr}&amount=${amount}&pos16511=${pos16511}`, function(data){
            resolve(data);
            if(reload) {
                window.location.reload();
            }
        }).fail((data)=>{
            reject(data);
        });
    });
}

shopApi.deleteCartPosition=(snr, reload=true)=>{
    return new Promise((resolve,reject)=>{
        $.get(`/api/cart/delete?snr=${snr}`, function(data){
            resolve(data);
            if(reload) {
                window.location.reload();
            }
            if(updateCartCounter){
                shopApi.updateCartCounter();
            }
        }).fail((data)=>{
            reject(data);
        });
    });
}

shopApi.clearCart=(reload=true)=>{
    return new Promise((resolve,reject)=>{
        $.get(`/api/cart/clear`, function(data){
            resolve(data);
            if(reload) {
                window.location.reload();
            }
            if(reload) {
                window.location.reload();
            }
        }).fail((data)=>{
            reject(data);
        });
    });
}

shopApi.getCartCount=()=>{
    return new Promise((resolve,reject)=>{
        $.get(`/api/cart/getcount`, function(data){
            resolve(data.data);
        }).fail((data)=>{
            reject(data);
        })
    });
};

shopApi.updateCartCounter=()=>{
    if(shopApi.cartUpdateTimer){
        clearTimeout(shopApi.cartUpdateTimer);
        shopApi.cartUpdateTimer=undefined;
    }
    shopApi.cartUpdateTimer=setTimeout(()=>{
        var cartCounter=document.getElementById("count-wk");
        if(cartCounter) {
            shopApi.getCartCount().then((data)=>{
                if(data){
                    cartCounter.innerHTML=data;
                }
            });
        }
        var respcartCounter=document.getElementById("resp-count-wk");
        if(wkitems) {
            shopApi.getCartCount().then((data)=>{
                if(data){
                    respcartCounter.innerHTML=data;
                }
            });
        }
        var wkitems=document.getElementById("wk-items");
        if(wkitems) {
            shopApi.getCartCount().then((data)=>{
                if(data){
                    wkitems.innerHTML=data;
                }
            });
        }
        shopApi.cartUpdateTimer=undefined;
    }, 1000);
   
}

shopApi.updateBeleg=(beleg)=>{
    return new Promise((resolve,reject)=>{
        $.ajax({
            type:"POST",
            url:"/api/beleg/update",
            contentType:"application/json",
            data: JSON.stringify(beleg),
            success:function(data){resolve(data);},
            error:function(data){reject(data)}
        });
    })
}

shopApi.createDeliveryAddress=(deliveryAddress)=>{
    return new Promise((resolve,reject)=>{
        $.ajax({
            type:"POST",
            url:"/api/deliveryAddress/create",
            contentType:"application/json",
            data: JSON.stringify(deliveryAddress),
            success:function(data){resolve(data);},
            error:function(data){reject(data)}
        });
    })
}

shopApi.updateDeliveryAddress=(deliveryAddress)=>{
    return new Promise((resolve,reject)=>{
        $.ajax({
            type:"POST",
            url:"/api/deliveryAddress/update",
            contentType:"application/json",
            data: JSON.stringify(deliveryAddress),
            success:function(data){resolve(data);},
            error:function(data){reject(data)}
        });
    })
}

shopApi.updateProfile=(profile)=>{
    return new Promise((resolve,reject)=>{
        $.ajax({
            type:"POST",
            url:"/api/profile/update",
            contentType:"application/json",
            data: JSON.stringify(profile),
            success:function(data){resolve(data);},
            error:function(data){reject(data)}
        })
    });
}

shopApi.loadRenderedOrders=(belegart="", startDate, endDate)=>{
    return new Promise((resolve,reject)=>{
        $.get(`./orderslist?belegart=${belegart}&startDate=${startDate}&endDate=${endDate}`, function(data){
            resolve(data);
        }).fail((data)=>{
            reject(data);
        });
    });
}

shopApi.loadRenderedOrderPositions=(belegindx)=>{
    return new Promise((resolve,reject)=>{
        $.get(`./orderposisions?belegindex=${belegindx}`, function(data){
            resolve(data);
        }).fail((data)=>{
            reject(data);
        });
    });
}

shopApi.loadRenderdOrderSummary=()=>{
    return new Promise((resolve,reject)=>{
        $.get(`./ordersummary`, function(data){
            resolve(data);
        }).fail((data)=>{
            reject(data);
        })
    });
}

shopApi.finishOrder=(beleg)=>{
    return new Promise((resolve,reject)=>{
        $.ajax({
            type:"POST",
            url:"./order/finish",
            contentType:"application/json",
            data: JSON.stringify(beleg),
            success:function(data){resolve(data);},
            error:function(data){reject(data)}
        })
    });
}

shopApi.getRelation=(id,params) => {
    let paramString="";
    for(let i=0;i<params.length;i++){
        paramString+="&P"+(i+1)+"="+params[i]
    }
    return new Promise((resolve, reject)=>{
        $.ajax({
            type:"POST",
            url:"/api/getRelation?id="+id+paramString,
            contentType:"application/json",
            success:function(data){resolve(data);},
            error:function(data){reject(data)}
        })
    });
}

shopApi.putRelation=(id,params) => {
    let paramString="";
    for(let i=0;i<params.length;i++){
        paramString+="&P"+(i+1)+"="+params[i]
    }
    return new Promise((resolve, reject)=>{
        $.ajax({
            type:"POST",
            url:"/api/putRelation?id="+id+paramString,
            contentType:"application/json",
            success:function(data){resolve(data);},
            error:function(data){reject(data)}
        })
    });
}

shopApi.startWorkflow=(wlfid, param)=>{
    return new Promise((resolve, reject)=>{
        $.ajax({
            type:"POST",
            url:`/api/workflow?id=${wlfid}&param=${param}`,
            contentType:"application/json",
            success:function(data){resolve(data);},
            error:function(data){reject(data)}
        })
    });
}

shopApi.belegNachdruck=(buttonElement, belegId, hinweisId)=>{
    const originalText = buttonElement.innerHTML;
    buttonElement.innerHTML = 'Beleg wird angefordert...';
    buttonElement.disabled = true;
    if (typeof shopApi !== "undefined" && typeof shopApi.startWorkflow === "function") {
        shopApi.startWorkflow('OS9980', belegId)
            .then(function(data) {
                if (data && data.success === true) {
                    
                    const hinweis = document.getElementById(hinweisId);
                    if (hinweis) {
                        hinweis.style.display = 'block';
                    }
                }
            })
            .catch(function(error) {
                console.error('Fehler beim Workflow:', error);
                buttonElement.innerHTML = 'Fehler';
            })
            .finally(function() {
                if (buttonElement.innerHTML !== 'Fehler') {
                    buttonElement.innerHTML = originalText;
                }
                buttonElement.disabled = false;
            });
    } else {
        console.error('shopApi ist nicht verfügbar.');
        buttonElement.innerHTML = 'Fehler';
        buttonElement.disabled = false;
    }
}
export default shopApi;